import { useEffect, useRef } from 'react';
import { Box } from '@mui/material';
import Chart from 'chart.js/auto';

const AttendanceChart = ({ employees, presentEmployees, vehicle }) => {
  const chartRef = useRef(null);
  const canvasRef = useRef(null);

  useEffect(() => {
    if (!canvasRef.current || !employees?.length) return;

    // Destroy previous instance before creating a new one
    if (chartRef.current) {
      chartRef.current.destroy();
      chartRef.current = null;
    }

    const usingTransport   = presentEmployees.length;
    const totalRegistered  = employees.length;
    const notUsingTransport = totalRegistered - usingTransport;
    const usagePct = totalRegistered > 0
      ? ((usingTransport / totalRegistered) * 100).toFixed(1)
      : '0.0';

    chartRef.current = new Chart(canvasRef.current, {
      type: 'pie',
      data: {
        labels: [
          `Present (${usingTransport})`,
          `Absent (${notUsingTransport})`,
        ],
        datasets: [{
          data: [usingTransport, notUsingTransport],
          backgroundColor: ['#4CAF50', '#F44336'],
          borderColor: ['#FFFFFF'],
          borderWidth: 2,
        }],
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          legend: { position: 'bottom', labels: { font: { size: 12 }, padding: 16 } },
          title: {
            display: true,
            text: [
              `Staff Transport Usage — ${usagePct}% Opted Today`,
              `Registered: ${totalRegistered}  |  Present: ${usingTransport}  |  Absent: ${notUsingTransport}`,
            ],
            font: { size: 13 },
            padding: { bottom: 10 },
          },
        },
      },
    });

    return () => {
      if (chartRef.current) {
        chartRef.current.destroy();
        chartRef.current = null;
      }
    };
  }, [employees, presentEmployees, vehicle]);

  return (
    <Box sx={{ width: '100%', maxWidth: 420 }}>
      <canvas ref={canvasRef} />
    </Box>
  );
};

export default AttendanceChart;